export const NUMBER_TABLE_STORE_KEY_UNASSIGNED = 'NUMBER_TABLE_STORE_KEY_UNASSIGNED'
export const NUMBER_TABLE_STORE_KEY_ASSIGNED = 'NUMBER_TABLE_STORE_KEY_ASSIGNED'
